// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_8EvGr","li_checked":"index_li_checked_h7hhr","span_checked":"index_span_checked_YfAxW"};